import React from "react";
import { Table, Typography } from "antd";
import dayjs from "dayjs";
import {
  nebulisationDoseOptions,
  nebulisationFrequencyOptions,
} from "../../../IpEMR/Options/careItemsOptions";

const { Paragraph } = Typography;

/**
 * Nebulisation orders arrive as care items:
 * [{ care_type__code, data: { name, frequency, notes }, order_date }].
 * Older/administered records instead carry `drug_name`, `action_time` and
 * `data.do_data`, so both shapes are read here.
 */
const getOrderedOn = (record) => record?.order_date || record?.action_time;

const getDetail = (record, key) =>
  record?.data?.[key] ?? record?.data?.do_data?.[key] ?? record?.[key];

const getOptionLabel = (options, value) =>
  options?.find((option) => option.value === value)?.label || value || "-";

const Nebulization = ({ details }) => {
  const nebulization = details?.data?.nebulization;

  const columns = [
    {
      title: "Started On",
      dataIndex: "order_date",
      key: "order_date",
      render: (_, record) => {
        const orderedOn = getOrderedOn(record);
        return orderedOn ? dayjs(orderedOn).format("DD, MMM hh:mm A") : "-";
      },
    },
    {
      title: "Name + Dose",
      dataIndex: "name",
      key: "name",
      render: (_, record) =>
        getOptionLabel(
          nebulisationDoseOptions,
          getDetail(record, "name") || record?.drug_name
        ),
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (_, record) =>
        getOptionLabel(
          nebulisationFrequencyOptions,
          getDetail(record, "frequency")
        ),
    },
    {
      title: "Comments",
      dataIndex: "notes",
      key: "notes",
      render: (_, record) => {
        const notes = getDetail(record, "notes") || getDetail(record, "comments");
        return notes ? (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "more",
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              marginBottom: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {notes}
          </Paragraph>
        ) : (
          "-"
        );
      },
    },
  ];

  return (
    <Table
      dataSource={nebulization}
      rowKey={(record, index) => `${getOrderedOn(record) || "nebulization"}-${index}`}
      pagination={false}
      columns={columns}
    />
  );
};

export default Nebulization;
